import { ADMIN_TYPES } from "services/types";

// Initial state
const INITIAL_STATE = {
  getSowListingResp: [],
  getSowListingLoading: true,

  addSowResp: [],
  addSowLoading: false,

  updateSowResp: [],
  updateSowLoading: false,

  SowDetails: {
    items: [],
    totalCount: 0,
  },
};

// Reducer function
export default function sowAbbrReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Pagination
    case ADMIN_TYPES.SOW_ABBR_PAGINATION_INIT:
      return {
        ...state,
        getSowListingResp: [],
        getSowListingLoading: true,
      };
    case ADMIN_TYPES.SOW_ABBR_PAGINATION_SUCCESS:
      return {
        ...state,
        SowDetails: {
          items: action.payload.item2,
          totalCount: action.payload.item1,
        },
        getSowListingLoading: false,
      };
    // case ADMIN_TYPES.SOW_ABBR_PAGINATION_ERROR:
    //   return {
    //     ...state,
    //     SowDetails: {
    //       ...state.SowDetails,
    //       loading: false,
    //       error: action.payload,
    //     },
    //   };

    case ADMIN_TYPES.SOW_ABBR_PAGINATION_FINISH:
      return {
        ...state,
        getSowListingLoading: false,
      };

    // Add
    case ADMIN_TYPES.SOW_ABBR_ADD_INIT:
      return {
        ...state,
        addSowResp: [],
        addSowLoading: true,
      };

    case ADMIN_TYPES.SOW_ABBR_ADD_SUCCESS:
      const updatedListAfterAdd = [action.payload, ...state?.SowDetails?.items];
      // console.log("SOW_ABBR_UPDATE_SUCCESS", updatedListAfterAdd);
      return {
        ...state,
        addSowLoading: false,
        SowDetails: {
          items: updatedListAfterAdd,
          totalCount: state?.SowDetails?.totalCount + 1, // Increment the total count
        },
      };

    case ADMIN_TYPES.SOW_ABBR_ADD_FINISH:
      return {
        ...state,
        addSowLoading: false,
      };

    // Update
    case ADMIN_TYPES.SOW_ABBR_UPDATE_INIT:
      return {
        ...state,
        updateSowLoading: true,
      };

    case ADMIN_TYPES.SOW_ABBR_UPDATE_SUCCESS:
      return {
        ...state,
        updateSowLoading: false,
        updateSowResp: action?.payload,
        SowDetails: {
          items: state?.SowDetails?.items
            ?.map((item) => {
              if (item.id === action.payload?.id) {
                return { ...action.payload };
              } else {
                return {
                  ...item,
                };
              }
            })
            .filter((item) => item !== null),
          totalCount: state?.SowDetails?.totalCount,
        },
      };

    case ADMIN_TYPES.SOW_ABBR_UPDATE_FINISH:
      return {
        ...state,
        updateSowLoading: false,
      };

    // Default case
    default:
      return state;
  }
}
